import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { themeRoundnessMultiplier } from "../constants";
import { useAppTheme } from "../useAppTheme";
import Box, { type BoxProps } from "./Box";
import Button from "./Button";
import RenderMarkdown from "./MarkdownRenderer";

type Props = {
	text: string;
	buttonProps?: {
		cta: string;
		onPress: () => void;
	};
	title?: string;
	fontSize?: number;
	containerAlignItems?: "flex-start" | "center";
	backgroundColor?: string;
	icon?: keyof typeof Icon.glyphMap;
	bottomComponent?: React.ReactNode;
	appFont?: string;
	padding?: number;
} & BoxProps;

const InfoAlert = ({
	text,
	buttonProps,
	title,
	fontSize = 14,
	containerAlignItems = "center",
	backgroundColor,
	icon,
	bottomComponent,
	appFont,
	padding = 16,
	...boxProps
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			padding={padding}
			borderRadius={theme.roundness * themeRoundnessMultiplier}
			backgroundColor={backgroundColor || theme.colors.primaryContainer}
			{...boxProps}
		>
			<View
				style={{
					flexDirection: "row",
					gap: 8,
					alignItems: containerAlignItems,
				}}
			>
				<Icon
					name={icon || "information-outline"}
					size={24}
					color={theme.colors.onPrimaryContainer}
				/>

				<Box flex={1}>
					{title && <Text variant="labelMedium">{title}</Text>}
					<RenderMarkdown
						text={text}
						appFont={appFont}
						fontSize={fontSize}
						customStyles={{
							text: {
								color: theme.colors.onPrimaryContainer,
								fontWeight: title ? undefined : "500",
							},
							paragraph: {
								marginVertical: 0,
							},
						}}
					/>
					{bottomComponent}
				</Box>
				{buttonProps && (
					<Button onPress={buttonProps.onPress}>{buttonProps.cta}</Button>
				)}
			</View>
		</Box>
	);
};

export default InfoAlert;
